import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { ProductDetailDescriptionView } from '@grandvisionhq/fun-products';
import ProductDetailLensesFeatures from '../../../../ProductDetailLensesFeatures/ProductDetailLensesFeatures.js';
import ProductDetailSpecification from '../../../../ProductDetailSpecification/ProductDetailSpecification.js';

const Description = ({ colorFeatureIcons , labels , lensFeatures , productFeatures , specificationVariant ,  })=>/*#__PURE__*/ React.createElement(ProductDetailDescriptionView, {
        header: labels.header,
        description: labels.description
    }, /*#__PURE__*/ React.createElement(ProductDetailLensesFeatures, swcHelpers.extends({
        color: colorFeatureIcons
    }, lensFeatures)), /*#__PURE__*/ React.createElement(ProductDetailSpecification, {
        configuration: productFeatures,
        variant: specificationVariant
    }))
;
var Description$1 = Description;

export { Description$1 as default };
//# sourceMappingURL=Description.js.map
